import React from "react";
import { MainSurveyStore } from "modules/MainSurveyEditor/hooks/useMainSurvey";
import { SurveyBlocks } from "modules/MainSurveyEditor/surveyBlocks";
import { useBulkConditions } from "../hooks/useBulkConditions";
import { ConditionsView } from "./ConditionsView";

interface BulkConditionsProps {
  mainSurveyStore: MainSurveyStore;
  selectedBlocks: SurveyBlocks.Block[];
  onSaved?: () => void;
}

export const BulkConditions = (props: BulkConditionsProps) => {
  const { mainSurveyStore, selectedBlocks, onSaved } = props;
  const { hasExtra, ...controller } = useBulkConditions(selectedBlocks, mainSurveyStore, onSaved);

  return (
    <ConditionsView
      mainSurveyStore={mainSurveyStore}
      controller={controller}
      extraNote={hasExtra ? "Some selected cells have additional conditions not shown here." : undefined}
    />
  );
};
